export const navList = [
  { text: '特色菜品', key: 'sjxBrandSpecial', url: '/sjx/brand/special' },
  { text: '门店环境', key: 'sjxBrandEnv', url: '/sjx/brand/env' },
  { text: '全国门店', key: 'sjxBrandShop', url: '/sjx/brand/shop' },
  { text: '品牌故事', key: 'sjxBrandStory', url: '/sjx/brand/story' },
];
